export default {
  // Acciones sobre un sprint (listado/tarjeta)
  labels: {
    sprints: 'Sprints',
    preview: 'Preview',
    edit: 'Edit sprint',
    edit_config: 'Configure sprint',
    delete: 'Delete sprint',
    desired_points: 'Points to accomplish'
  },

  // Formulario de creacion de un sprint
  create: {
    name: 'Sprint name',
    description: 'Sprint description',
    role: 'Role assigned',
    franchise: 'Franchise assigned'
  }
}
